export const calendarCardTheme = {
  audit: {
    id: '1',
    name: 'Audit',
    color: '#fff',
    bgColor: '#72B566',
    dragBgColor: '#72B566',
    borderColor: '#72B566',
  },
  capture: {
    id: '2',
    name: 'Capture',
    color: '#fff',
    bgColor: '#9766C9',
    dragBgColor: '#9766C9',
    borderColor: '#9766C9',
  },
  ciscoApiEnrichment: {
    id: '3',
    name: 'Cisco API Enrichment',
    color: '#fff',
    bgColor: '#66B5B0',
    dragBgColor: '#66B5B0',
    borderColor: '#66B5B0',
  },
  runDataRetention: {
    id: '4',
    name: 'Data Retention',
    color: '#fff',
    bgColor: '#E74EB3',
    dragBgColor: '#E74EB3',
    borderColor: '#E74EB3',
  },
  plan: {
    id: '5',
    name: 'Plan',
    color: '#fff',
    bgColor: '#E64E7C',
    dragBgColor: '#E64E7C',
    borderColor: '#E64E7C',
  },
  ProvisionFeatures: {
    id: '6',
    name: 'Provision Features',
    color: '#fff',
    bgColor: '#EC3323',
    dragBgColor: '#EC3323',
    borderColor: '#EC3323',
  },
  reboot: {
    id: '7',
    name: 'Reboot',
    color: '#fff',
    bgColor: '#6F81DF',
    dragBgColor: '#6F81DF',
    borderColor: '#6F81DF',
  },
  'audit-past': {
    id: '8',
    name: 'Audit',
    color: '#fff',
    bgColor: '#72b566b3',
    dragBgColor: '#72b566b3',
    borderColor: '#72B566',
  },
  'capture-past': {
    id: '9',
    name: 'Capture',
    color: '#fff',
    bgColor: '#9766c9b3',
    dragBgColor: '#9766c9b3',
    borderColor: '#9766C9',
  },
  'ciscoApiEnrichment-past': {
    id: '10',
    name: 'Cisco API Enrichment',
    color: '#fff',
    bgColor: '#66b5b0b3',
    dragBgColor: '#66b5b0b3',
    borderColor: '#66B5B0',
  },
  'runDataRetention-past': {
    id: '11',
    name: 'Data Retention',
    color: '#fff',
    bgColor: '#e74eb3b3',
    dragBgColor: '#e74eb3b3',
    borderColor: '#E74EB3',
  },
  'plan-past': {
    id: '12',
    name: 'Plan',
    color: '#fff',
    bgColor: '#e64e7cb3',
    dragBgColor: '#e64e7cb3',
    borderColor: '#E64E7C',
  },
  'ProvisionFeatures-past': {
    id: '13',
    name: 'Provision Features',
    color: '#fff',
    bgColor: '#ec3323b3',
    dragBgColor: '#ec3323b3',
    borderColor: '#ec3323',
  },
  'reboot-past': {
    id: '14',
    name: 'Reboot',
    color: '#fff',
    bgColor: '#6F81DFb3',
    dragBgColor: '#6F81DFb3',
    borderColor: '#6F81DFb3',
  },
};

export const viewType = [
  {value: 'day', label: 'Daily'},
  {value: 'week', label: 'Weekly'},
  {value: 'month', label: 'Monthly'},
];

export const workType = [
  {value: 'all', label: 'All'},
  {value: 'audit', label: 'Audit'},
  {value: 'capture', label: 'Capture'},
  {value: 'ciscoApiEnrichment', label: 'Cisco API'},
  {value: 'plan', label: 'OS Plan'},
  {value: 'ProvisionFeatures', label: 'Provisioning'},
  {value: 'reboot', label: 'Reboot'},
  {value: 'runDataRetention', label: 'Data Retention'},
];

export const CUSTOM_THEME = {
  'month.schedule.borderRadius': '5px',
  'month.schedule.height': '18px',
  'month.schedule.marginTop': '2px',
  'month.schedule.marginLeft': '10px',
  'month.schedule.marginRight': '10px',
  'week.dayGridSchedule.borderRadius': '0',
  'week.dayGridSchedule.height': '18px',
  'week.dayGridSchedule.marginTop': '2px',
  'week.dayGridSchedule.marginLeft': '10px',
  'week.dayGridSchedule.marginRight': '10px',
};

export const Statuses = {
  STARTING: 'Starting',
  RUNNING: 'Running',
  SUCCESSFUL: 'Successful',
  FAILED: 'Failed',
  SKIPPED: 'Skipped',
  MISSED: 'Missed',
  OVERLAPPED: 'Overlapped',
};
